module.exports = __webpack_public_path__ + "src/assets/img/zoom_out.ff80cb65.svg";